export default __webpack_public_path__ + "static/hdpost1-3875ed3ce1ac8abb82efa53eaf0e0111.jpeg";